export class MyCompanyDataModel {
  logo?: any;
  logoContentType?: any;
  companyLogo?: any;
  logoName?: any;
  logoSizeInBytes?: any;

  constructor() {
    Object.assign(this);
  }
}
